let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7f0Ao")).then(() => parcelRequire('6NDIz'));